import type { ActivityType } from '@agrogruda/shared';
import { supabase, type Profile } from './supabase';

export type ActivityActor = Pick<Profile, 'id' | 'name' | 'role'>;

/**
 * Prototype `log(type, text, detail)` (line 1608). Inserts into `activities` with the current profile as
 * user_id/user_name/user_role (RLS policy activities_insert_own requires user_id = auth.uid()).
 * Resolves to false when the insert was refused; logging never blocks the user flow.
 */
export async function logActivity(
  actor: ActivityActor,
  type: ActivityType,
  text: string,
  detail = '',
): Promise<boolean> {
  const { error } = await supabase.from('activities').insert({
    type,
    text,
    detail,
    user_id: actor.id,
    user_name: actor.name,
    user_role: actor.role,
  });
  return error === null;
}
